module.exports = __webpack_public_path__ + "img/icon-star.413556cf.svg";